/**
 * CLEMENTINA CUSTOM: Box Flavors Selector
 * Handles the multi-flavor selection UI for box products
 */
(function () {
  function initMultiBox() {
    // Find all instances of the selector (supports multiple on page)
    const roots = document.querySelectorAll('[id^="multi-box-flavors-selector-"]');
    roots.forEach(initSelectorInstance);
  }

  function initSelectorInstance(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    // Find the real /cart/add form (Horizon puts it in Buy Buttons)
    const addToCartForm =
      root.closest('form') ||
      document.querySelector('form[action="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    if (!addToCartForm) {
      console.warn('[multi-box] No form found');
      return;
    }

    // Move hidden inputs into form if not already there
    const hiddenInputs = root.querySelectorAll('input[name^="properties["]');
    hiddenInputs.forEach(function (input) {
      if (!addToCartForm.contains(input)) {
        addToCartForm.appendChild(input);
      }
    });

    const modesContainer = root.querySelector('.multi-box-flavors__modes');
    const totalItems = parseInt(modesContainer.dataset.totalItems, 10);
    const itemName = modesContainer.dataset.itemName;
    const maxFlavors = parseInt(modesContainer.dataset.maxFlavors, 10);
    const shouldPrefill = root.dataset.prefill === 'true';

    const dropdownsContainer = root.querySelector('.multi-box-flavors__dropdowns');
    const flavorListJson = dropdownsContainer.dataset.flavors;

    let flavorLabels = [];
    try {
      flavorLabels = JSON.parse(flavorListJson);
    } catch (e) {
      console.warn('[multi-box] Could not parse flavors JSON', e);
    }

    const FLAVORS = flavorLabels.map((label) => ({
      label,
      value: label
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, ''),
    }));

    const modeButtons = root.querySelectorAll('.multi-box-flavors__mode-btn');
    const propMode = addToCartForm.querySelector('input[data-prop="mode"]');
    const propSlots = [];

    for (let i = 1; i <= 9; i++) {
      const p = addToCartForm.querySelector('input[data-prop="slot-' + i + '"]');
      if (p) propSlots.push(p);
    }

    const errorEl = root.querySelector('.multi-box-flavors__error');
    const addToCartButton =
      addToCartForm.querySelector('[type="submit"]') ||
      addToCartForm.querySelector('button[name="add"]');

    let currentFlavorCount = null;
    let currentSelects = [];

    function itemsPerSlot(n) {
      return Math.floor(totalItems / n);
    }

    function clearDropdowns() {
      dropdownsContainer
        .querySelectorAll('.multi-box-flavors__dropdown-group')
        .forEach((el) => el.remove());
      currentSelects = [];
    }

    function createDropdownGroup(slotIndex, slotsTotal) {
      const group = document.createElement('div');
      group.className = 'multi-box-flavors__dropdown-group';

      const perSlot = itemsPerSlot(slotsTotal);

      const label = document.createElement('label');
      label.className = 'multi-box-flavors__dropdown-label';
      label.textContent =
        slotsTotal === 1
          ? 'Saveur unique · ' + perSlot + ' ' + itemName
          : 'Saveur ' + slotIndex + ' · ' + perSlot + ' ' + itemName;

      const select = document.createElement('select');
      select.className = 'multi-box-flavors__select';
      select.setAttribute('data-select-slot', slotIndex);

      const opt0 = document.createElement('option');
      opt0.value = '';
      opt0.textContent = 'Choisir une saveur…';
      select.appendChild(opt0);

      FLAVORS.forEach((f) => {
        const opt = document.createElement('option');
        opt.value = f.value;
        opt.textContent = f.label;
        select.appendChild(opt);
      });

      group.appendChild(label);
      group.appendChild(select);

      const note = dropdownsContainer.querySelector('.multi-box-flavors__note');
      dropdownsContainer.insertBefore(group, note);

      select.addEventListener('change', syncHiddenInputs);
      currentSelects.push(select);
    }

    function isSelectionValid() {
      if (!currentFlavorCount) return false;
      return currentSelects.every((sel) => sel.value);
    }

    function updateAddToCartState() {
      if (!addToCartButton) return;

      const valid = isSelectionValid();
      addToCartButton.disabled = !valid;
      errorEl.style.display = valid || !currentFlavorCount ? 'none' : 'block';

      if (currentFlavorCount) {
        root.classList.add('multi-box-flavors--active');
      } else {
        root.classList.remove('multi-box-flavors--active');
      }
    }

    function setDefaultSelections() {
      currentSelects.forEach(function (select) {
        select.value = '';
      });

      // Pre-fill: use the first N flavors based on slots (if enabled)
      if (shouldPrefill) {
        currentSelects.forEach(function (select, index) {
          if (FLAVORS[index]) {
            select.value = FLAVORS[index].value;
          }
        });
      }

      syncHiddenInputs();
    }

    function syncHiddenInputs() {
      if (!currentFlavorCount) {
        propMode.value = '';
        propSlots.forEach((p) => (p.value = ''));
        updateAddToCartState();
        return;
      }

      const perSlot = itemsPerSlot(currentFlavorCount);
      propMode.value =
        currentFlavorCount +
        ' saveur' +
        (currentFlavorCount > 1 ? 's' : '') +
        ' (' +
        currentFlavorCount +
        ' x ' +
        perSlot +
        ' ' +
        itemName +
        ')';

      propSlots.forEach((p) => (p.value = ''));

      currentSelects.forEach((sel) => {
        const idx = parseInt(sel.dataset.selectSlot) - 1;
        const flavor = FLAVORS.find((f) => f.value === sel.value);
        if (flavor && propSlots[idx]) {
          propSlots[idx].value = flavor.label + ' (' + perSlot + ' ' + itemName + ')';
        }
      });

      updateAddToCartState();
    }

    function updateVisibleSlots(num) {
      if (!num) {
        dropdownsContainer.classList.remove('multi-box-flavors__dropdowns--open');
        dropdownsContainer.setAttribute('aria-hidden', 'true');
        clearDropdowns();
        currentFlavorCount = null;
        syncHiddenInputs();
        return;
      }

      dropdownsContainer.classList.add('multi-box-flavors__dropdowns--open');
      dropdownsContainer.setAttribute('aria-hidden', 'false');

      clearDropdowns();
      for (let i = 1; i <= num; i++) {
        createDropdownGroup(i, num);
      }
      setDefaultSelections();
    }

    modeButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const n = parseInt(btn.dataset.flavorCount);

        if (currentFlavorCount === n) {
          // Toggle off if clicking the same button
          currentFlavorCount = null;
          modeButtons.forEach((b) =>
            b.classList.remove('multi-box-flavors__mode-btn--active')
          );
          updateVisibleSlots(null);
          return;
        }

        currentFlavorCount = n;
        modeButtons.forEach((b) =>
          b.classList.toggle(
            'multi-box-flavors__mode-btn--active',
            parseInt(b.dataset.flavorCount) === n
          )
        );
        updateVisibleSlots(n);
      });
    });

    addToCartForm.addEventListener('submit', function (evt) {
      if (!isSelectionValid()) {
        evt.preventDefault();
        errorEl.style.display = 'block';
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    // Initialize with no selection
    updateVisibleSlots(null);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMultiBox);
  } else {
    initMultiBox();
  }

  // Re-initialize on Shopify section reload (for theme editor)
  document.addEventListener('shopify:section:load', initMultiBox);
})();

